import { render } from "./BinItem.vue?vue&type=template&id=03e22fb6"
import script from "./BinItem.vue?vue&type=script&lang=js"
export * from "./BinItem.vue?vue&type=script&lang=js"
script.render = render

export default script